import { log } from './log';
import { isWx } from './base';
import invokeClient from './invokeClient';
const setWeChat = ({ title, desc, link, imgUrl }) => {
    const business = 2;
    const url = window.location.href.split('#')[0];
    fetch(`/cgi-op/api/v1/wechat/getJsSdkConfig?business=${business}&url=${encodeURIComponent(url)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then((res) => res.json())
        .then((res) => {
        const data = res.data;
        const wx = window.wx;
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData',
            ],
        });
        wx.ready(() => {
            // 分享给朋友
            wx.updateAppMessageShareData({
                title,
                desc,
                link,
                imgUrl,
                success: () => {
                    // 设置成功
                },
            });
            // 分享到朋友圈
            wx.updateTimelineShareData({
                title,
                link,
                imgUrl,
                success: () => {
                    // 设置成功
                },
            });
        });
        wx.error((err) => {
            console.log('配置失败:', err);
        });
    })
        .catch((err) => {
        console.log('获取签名失败:', err);
    });
};
let shareOption = {};
// 这个函数供客户端主动调用
// 如果此时分享数据为空，则进行填充
export const getShareData = () => {
    log('客户端获取分享数据陈成功');
    shareOption.title = shareOption.title || document.title;
    shareOption.description =
        shareOption.description || '你的朋友分享了一些好东西给你';
    shareOption.url = shareOption.url || window.location.href;
    // 默认值为米家的logo
    shareOption.imageUrl =
        shareOption.imageUrl ||
            'http://cdn.cnbj0.fds.api.mi-img.com/miio.files/commonfile_png_31e7e094020bfbb0262dab94b1ab84f2.png';
    return shareOption;
};
export const setShareData = ({ title, description, url, imageUrl, }) => {
    var _a;
    shareOption.title = title;
    shareOption.description = description;
    shareOption.url = url;
    shareOption.imageUrl = imageUrl;
    log('设置分享数据', shareOption);
    if (isWx) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
        (_a = document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.appendChild(script);
        script.onload = function () {
            const shareData = getShareData();
            setWeChat({
                title: shareData.title,
                desc: shareData.description,
                link: shareData.url,
                imgUrl: shareData.imageUrl,
            });
        };
    }
};
export const triggerShare = (params = {}) => {
    return invokeClient.invoke({
        functionName: 'triggerShare',
        params: JSON.stringify(params),
    });
};
//# sourceMappingURL=data:application/json;base64,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